export default function getResource(label) {
    const resources = {
        freeReturns: 'Free returns on all purchases*',
        infoIcon: 'Free Returns info'
    };

    return resources[label];
}
